import { DATA, OPTIONAL_KEY, Resource } from "shelving";
import { CONTENT_ENTITY } from "../schema/entity.js";

export const SET_REACTION = new Resource("setReaction", DATA({ target: CONTENT_ENTITY, reaction: OPTIONAL_KEY }));
